import { IOptionTypeCollection } from '../ListingDetail.types';

export const getDropdownValueFromApi = (
  options: IOptionTypeCollection,
  value: number | string | undefined,
) => {
  if (value === undefined) {
    return undefined;
  }

  return Object.values(options).find(item => item.value === value);
};
